import React, { useMemo } from 'react'
import { Modal } from 'react-bootstrap';

const HotelBookingDetailPopup = (props) => {
    const { hotelData, show, setShow, activeTab } = props;

    const closeModal = () => {
        setShow(false)
    }

    const formateDateMonthYear = (date) => {
        const d = new Date(date);
        const day = d?.toLocaleString("en-US", { day: 'numeric' });
        const month = d?.toLocaleString("en-US", { month: 'short' });
        const year = d?.toLocaleString("en-US", { year: 'numeric' });
        return date ? `${day}-${month}-${year}` : null;
    }

    const dateFormat = (date) => {
        const d = new Date(date);
        const weekday = d?.toLocaleString("en-US", { weekday: 'short' });
        const day = d?.toLocaleString("en-US", { day: 'numeric' });
        const month = d?.toLocaleString("en-US", { month: 'short' });
        const year = d?.toLocaleString("en-US", { year: 'numeric' });
        return date ? `${day} ${month} ${year}, ${weekday}` : null;
    }

    const getGenderType = (type) => {
        if (type === "") {
            return "N/A";
        }
        else if (type === "Mr") {
            return "Male";
        }
        else {
            return "Female";
        }
    }

    const passengerData = useMemo(() =>
        hotelData?.getBookingDetailResult?.rooms?.reduce((acc, curr, index, arr) => {
            curr?.hotelPassenger?.map((pass, index) => {
                acc = [...acc, pass]
            })
            return acc;
        }, [])
        , [hotelData])


    return (
        <>
            <Modal
                show={show}
                onHide={() => closeModal()}
                size="xl"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                dialogClassName="sign-in-class flight_booking_detail"
                centered
            >
                <div className="modal-content border_outline">
                    <div className="modal-header py-2 border-0 row">
                        <div className="col-12 position-relative">
                            <div className='text-end'>
                                <button type="button" onClick={closeModal} className="btn booking_detail_close" data-bs-dismiss="modal" aria-label="Close"><i className="fa-solid fa-xmark"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="modal-body px-0 pt-0">
                        <div className="label_title">
                            Booking Details
                        </div>

                        <div className="py-2 px-1">
                            <table className='booking_detail_table w-100 text-center'>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className='fw-bold'> ETM Ref. ID </div>
                                        </td>
                                        <td>
                                            <div className=''> {hotelData?.data?.BookingNo} </div>
                                        </td>
                                        <td className='p-0' >
                                            <div style={{ backgroundColor: '#0777A9' }} ></div>
                                        </td>
                                        <td>
                                            <div className='fw-bold'> Booking ID. </div>
                                        </td>
                                        <td>
                                            <div className=''> {hotelData?.getBookingDetailResult?.bookingId} </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <div className='fw-bold'> Confirmation no. </div>
                                        </td>
                                        <td>
                                            <div className=''> {hotelData?.getBookingDetailResult?.confirmationNo} </div>
                                        </td>
                                        <td className='p-0' >
                                            <div style={{ backgroundColor: '#0777A9' }} ></div>
                                        </td>
                                        <td>
                                            <div className='fw-bold'> Supplier </div>
                                        </td>
                                        <td>
                                            <div className=''> TBO </div>
                                        </td>
                                    </tr>

                                    <tr>

                                        <td>
                                            <div className='fw-bold'> Hotel Name </div>
                                        </td>
                                        <td>
                                            <div className=''> {hotelData?.getBookingDetailResult?.hotelDetails?.[0]?.hotelName} </div>
                                        </td>
                                        <td className='p-0' >
                                            <div style={{ backgroundColor: '#0777A9' }} ></div>
                                        </td>
                                        <td>
                                            <div className='fw-bold'> Booking Date </div>
                                        </td>
                                        <td>
                                            <div className=''> {dateFormat(hotelData?.getBookingDetailResult?.bookingDate)} </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <div className='fw-bold'> Check in date </div>
                                        </td>
                                        <td>
                                            <div className=''>
                                                {formateDateMonthYear(hotelData?.getBookingDetailResult?.checkInDate)}
                                            </div>
                                        </td>
                                        <td className='p-0' >
                                            <div style={{ backgroundColor: '#0777A9' }} ></div>
                                        </td>
                                        <td>
                                            <div className='fw-bold'> Check out date </div>
                                        </td>
                                        <td>
                                            <div className=''> {formateDateMonthYear(hotelData?.getBookingDetailResult?.checkOutDate)} </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <div className='fw-bold'> Hotel Address </div>
                                        </td>
                                        <td>
                                            <div className=''>
                                                {hotelData?.getBookingDetailResult?.hotelDetails?.[0]?.address}
                                            </div>
                                        </td>
                                        <td className='p-0' >
                                            <div style={{ backgroundColor: '#0777A9' }} ></div>
                                        </td>
                                        <td>
                                            <div className='fw-bold'> Room Type </div>
                                        </td>
                                        <td>
                                            <div className=''> {hotelData?.getBookingDetailResult?.rooms?.[0]?.roomTypeName} </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <div className="label_title">
                            Pax Details
                        </div>

                        <div className="py-1 px-1">
                            <div className='overflow-auto'>
                                <table className='Passanger_detail_table w-100 text-center fs_14' style={{ wordBreak: 'break-word' }}>
                                    <thead>
                                        <tr>
                                            <th>P. No</th>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>Gender</th>
                                            <th>Age</th>
                                            <th>Contact No.</th>
                                            <th>Email ID</th>
                                            {/* <th>Extra Mattress/Bed</th> */}
                                            <th>Meal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            passengerData?.map((passenger, index) => {
                                                return (
                                                    <tr key={`${passenger?.firstName}${index}`} >
                                                        <td style={{ minWidth: '50px' }}> <div> {index + 1} </div> </td>
                                                        <td style={{ minWidth: '100px' }}> <div> {passenger?.firstName || "N/A"} </div> </td>
                                                        <td style={{ minWidth: '100px' }}> <div> {passenger?.lastName || "N/A"} </div> </td>
                                                        <td style={{ minWidth: '80px' }}> <div> {getGenderType(passenger?.title) || "N/A"} </div> </td>
                                                        <td style={{ minWidth: '50px' }}> <div> {passenger?.age || "N/A"} </div> </td>
                                                        <td style={{ minWidth: '110px' }}> <div> {passenger?.phoneno || "N/A"} </div> </td>
                                                        <td style={{ minWidth: '150px' }}> <div> {passenger?.email || "N/A"} </div> </td>
                                                        {/* <td style={{ minWidth: '150px' }}> <div> {passenger?.extra || "N/A"} </div> </td> */}
                                                        <td style={{ minWidth: '150px' }}> <div> N/A </div> </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        </>
    )
}

export default HotelBookingDetailPopup
